module.exports = __webpack_public_path__ + "media/images/smart_phone/toplogo_07-6f806ad45e43395f1f4490c561ae8622.png";